
const chatElement = document.getElementById("sc-support-chat");
const chatVisibility = (visibility) => {
	if (!chatElement) return;
	chatElement.style.visibility = visibility === "hidden" ? "hidden" : "visible";
};

export default {
	shutdown() {
		chatVisibility("hidden");
	},
	identify(params) {
		// Si MessageBird permite identificación (como userId, nombre, email), deberías usar attributes.
		// Documentación sugiere pasar atributos como 'user-id', 'user-name', etc., directamente al tag
		if (chatElement) {
			Object.entries(params).forEach(([key, value]) => {
				chatElement.setAttribute(`user-${key}`, value);
			});
		}
	},
	start() {
		chatVisibility("visible");
	},
	openChat() {
		if (!chatElement) return;

		console.log('open chat')
		// Mostrar chat (por si está oculto)
		chatElement.style.visibility = "visible";

		// Simular apertura si soporta métodos JS (algunos chats lo hacen)
		// Aquí no hay una API JS documentada, pero puedes disparar focus como workaround:
		setTimeout(() => {
			chatElement.shadowRoot?.querySelector('iframe')?.focus(); // intento de enfoque
		}, 1000);
	}
};